import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMsal } from '@azure/msal-react'
import {
  CAvatar,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilAccountLogout } from '@coreui/icons'

const avatarPlaceholder =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgZmlsbD0iIzZjNzU3ZCIvPjxwYXRoIGQ9Ik0yMCAyMGM0LjE0MiAwIDcuNS0zLjM1OCA3LjUtNy41UzI0LjE0MiA1IDIwIDVzLTcuNSAzLjM1OC03LjUgNy41IDMuMzU4IDcuNSA3LjUgNy41em0wIDMuNzVjLTUuMDA0IDAtMTUgMi41MDQtMTUgNy41VjM1aDMwdi0zLjc1YzAtNC45OTYtOS45OTYtNy41LTE1LTcuNXoiIGZpbGw9IiNmZmYiLz48L3N2Zz4='

const AppHeaderDropdown: React.FC = () => {
  const { t } = useTranslation()
  const { instance, accounts } = useMsal()
  const account = accounts[0]
  const isAuthenticated = accounts.length > 0

  const handleLogout = () =>
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin })

  return (
    <CDropdown variant="nav-item" placement="bottom-end">
      <CDropdownToggle className="py-0 pe-0" caret={false}>
        <CAvatar src={avatarPlaceholder} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        <CDropdownHeader className="bg-body-secondary fw-semibold mb-2">
          {t('common:header.account')}
        </CDropdownHeader>
        {isAuthenticated && account?.name && (
          <CDropdownItem disabled className="text-body-secondary">
            {account.name}
          </CDropdownItem>
        )}
        <CDropdownItem as="button" onClick={handleLogout}>
          <CIcon icon={cilAccountLogout} className="me-2" />
          {t('common:header.logout')}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
